if(!customElements.get('product-model')){
    class ProductModel extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.template = this.querySelector('template');
            this.modelViewerWrapper = this.querySelector('.model-viewer-wrapper');
            this.modelThumbnail = this.querySelector('.model-thumbnail');
            this.model3dWrapper = this.querySelector('.model-3d-wrapper');

            this.productDetails = this.closest('custom-product-details');

            if(this.querySelector('.icon-model-viewer')){
                this.querySelector('.icon-model-viewer').addEventListener('click', this.loadProductModel.bind(this));
            }
            if(this.querySelector('.icon-mobile-model-viewer')){
                this.querySelector('.icon-mobile-model-viewer').addEventListener('click', this.loadProductModel.bind(this));
            }
        
            this.btnClose = this.querySelector('.btn-close');
            this.btnClose.addEventListener('click', this.closeProductModel.bind(this));
        }

        refresh(){
            this.init();
        }

        loadProductModel(){
            this.modelViewerWrapper.setAttribute('data-active', 'true');
            if(this.model3dWrapper.innerHTML == ''){
                this.model3dWrapper.append(this.template.content);
            }

            if(this.productDetails && this.productDetails.swiper) this.productDetails.swiper.allowTouchMove = false;
        }

        closeProductModel(){
            this.modelViewerWrapper.setAttribute('data-active', 'false');

            if(this.productDetails && this.productDetails.swiper) this.productDetails.swiper.allowTouchMove = true;
        }
    }

    customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-media-image')){
    class ProductZoomImage extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.index = this.dataset.idx;
            this.scrollDetected = false;

            if(!this.index) return;
            if(this.dataset.disableZoom == 'true') return;

            this.image = this.querySelector('.img-original');
            this.imageWrapper = this.querySelector('.img-wrapper');
            this.zoomInIcon = this.querySelector('.icon-zoom');
            this.productDetails = this.closest('custom-product-details, custom-featured-product');

            this.isZoomed = false;
            this.isDragging = false;
            this.initialX = 0;
            this.initialY = 0;
            this.numClick = 0;

            this.lastMoveTime = 0;
            this.lastX = 0;
            this.lastY = 0;
            this.velocityX = 0;
            this.velocityY = 0;
            this.doubleTapThreshold = 300; // Time in ms to detect double tap

            this.isScrolling;
            this.touchStartY = 0;
            this.touchStartX = 0;
            this.touchEndY = 0;
            this.touchEndX = 0;
            this.zoomDetected = false;

            this.zoomInIcon.addEventListener('click', () => {
                this.zoomIn();
            })
            this.image.addEventListener('dblclick', () => {
                if(this.isZoomed){
                    this.zoomOut();
                }else{
                    this.zoomIn();
                }
            });

            this.image.addEventListener('mousedown', this.startDragging.bind(this));
            this.image.addEventListener('mouseup', this.stopDragging.bind(this));
            this.image.addEventListener('mousemove', this.dragImage.bind(this));
            this.image.addEventListener('mouseleave', this.stopDragging.bind(this));

            this.image.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
            this.image.addEventListener('touchend', this.handleTouchEnd.bind(this));
            this.image.addEventListener('touchmove', this.dragImage.bind(this), { passive: false});

            this.btnClose = this.closest('.swiper-container')? this.closest('.swiper-container').querySelector('.btn-close--zoom-image')
                : this.closest('.product-media-image-wrapper')? this.closest('.product-media-image-wrapper').querySelector('.btn-close--zoom-image') : null;

            if(this.btnClose){
                this.btnClose.addEventListener('click', () => {
                    this.stopDragging();
                    this.zoomOut();
                });
            }
        }

        refresh(){
            this.init();
        }

        startDragging(e){
            if(!this.isZoomed) return;

            e.preventDefault();
            this.isDragging = true;
            const event = e.touches ? e.touches[0] : e;
            this.startX = event.clientX - this.initialX;
            this.startY = event.clientY - this.initialY;
            this.image.style.cursor = 'grabbing';


            this.lastMoveTime = Date.now();
            this.lastX = event.clientX;
            this.lastY = event.clientY;
        }

        handleTouchStart(e){
            if(e.touches.length > 1){
                this.zoomDetected = true;
                this.scrollDetected = false;
            }else{
                this.zoomDetected = false;
                this.touchStartY = e.touches[0].clientY;
                this.touchStartX = e.touches[0].clientX;
                this.detectScrolling(e);
            }

            if(!this.scrollDetected){
                this.startDragging(e);
                document.body.classList.add('no-scroll');
            }
        }

        handleTouchEnd(){
            if(this.scrollDetected) return;
            this.stopDragging();

            const currentTime = new Date().getTime();
            const tapInterval = currentTime - this.lastTapTime;

            if (tapInterval < this.doubleTapThreshold && tapInterval > 0) {
                // Detected a double tap
                if (this.isZoomed) {
                    this.zoomOut();
                } else {
                    this.zoomIn();
                }
            }

            this.lastTapTime = currentTime;

            setTimeout(() => {
                document.body.classList.remove('no-scroll');
            }, 1000);
        }

        stopDragging(){
            if(this.scrollDetected) return;

            this.isDragging = false;
            this.image.style.cursor = 'grab';
        }

        dragImage(e){
            if(!this.isDragging) return;
            if(this.scrollDetected == true) return;
            if(this.isZoomed !== true) return;
 
            const event = e.touches ? e.touches[0] : e;
            const currentX = event.clientX;
            const currentY = event.clientY;
            const currentTime = Date.now();

            const deltaX = currentX - this.lastX;
            const deltaY = currentY - this.lastY;
            const deltaTime = currentTime - this.lastMoveTime;  
            
            this.velocityX = deltaX / deltaTime;
            this.velocityY = deltaY / deltaTime;

            this.lastMoveTime = currentTime;
            this.lastX = currentX;
            this.lastY = currentY;

            const dragFactor = 5;
            
            this.initialX = event.clientX - this.startX + this.velocityX * dragFactor;
            this.initialY = event.clientY - this.startY + this.velocityY * dragFactor;

            const imageRect = this.image.getBoundingClientRect();
            const wrapperRect = this.imageWrapper.getBoundingClientRect();

            const maxTranslateX = wrapperRect.width / 2;
            const maxTranslateY = wrapperRect.height / 2;
            const minTranslateX = wrapperRect.width - imageRect.width * 2 / 2;
            const minTranslateY = wrapperRect.height - imageRect.height * 2 / 2;

            const translateX = Math.min(Math.max(this.initialX, (minTranslateX / 2)), maxTranslateX);
            const translateY = Math.min(Math.max(this.initialY, (minTranslateY / 2)), maxTranslateY);

            this.initialX = translateX;
            this.initialY = translateY;

            this.image.style.transform = `translate3d(${translateX}px, ${translateY}px, 0px) scale3d(2, 2, 1)`;
        }

        detectScrolling(e){
            if(this.isZoomed){ // in zoom status
                this.scrollDetected = false;
            }else if(!this.zoomDetected){ // click to be zoomed
                this.touchEndY = e.touches[0].clientY;
                this.touchEndX = e.touches[0].clientX;

                clearTimeout(this.isScrolling);
                this.isScrolling = setTimeout(() => {
                    const deltaY = Math.abs(this.touchEndY - this.touchStartY);
                    const deltaX = Math.abs(this.touchEndX - this.touchStartX);
            
                    if (deltaY > deltaX) {
                        this.scrollDetected = true;
                    } else {
                        this.scrollDetected = false;
                    }
                }, 100);
            }else{
                this.scrollDetected = false;
            }
        }

        zoomIn(){
            if(this.dataset.disableZoom == 'true') return;

            this.image.style.transform = 'scale3d(2, 2, 1)';
            this.isZoomed = true;
            if(this.btnClose) {
                this.btnClose.classList.remove('d-none');
            }

            if(this.closest('.swiper-container')){
                if(this.productDetails) {
                    this.productDetails.disableTouchSwipe();
                }
            }

            this.imageWrapper.dataset.active = 'true';
        }

        zoomOut(){
            if(this.dataset.disableZoom == 'true') return;

            this.image.style.transform = 'scale3d(1, 1, 1)';
            this.isZoomed = false;
            this.image.style.top = '0';
            this.image.style.left = '0';
            this.initialX = 0;
            this.initialY = 0;

            if(this.btnClose) this.btnClose.classList.add('d-none');

            if(this.closest('.swiper-container')){
                if(this.productDetails){
                    this.productDetails.enableTouchSwipe();
                }
            }
            this.imageWrapper.dataset.active = 'false';
        }
    }
    customElements.define('product-media-image', ProductZoomImage);
}

if(!customElements.get('custom-product-details')){
    class ProductDetails extends HTMLElement {
        constructor(){
            super();
        }

        submitToCart(e){
            e.preventDefault();

            if(this.btnCart.getAttribute('data-disabled') == 'true') return;
    
            // remove sold out message
            if(this.querySelector('.badge--sold-out')){
               this.querySelector('.price').classList.remove('price--sold-out');
               this.querySelector('.badge--sold-out').remove();
            }

            const formData = new FormData(this.form);

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch('/cart/add', config)
            .then(res => res.json())
            .then(res => {
                this.recipientForm = this.querySelector('recipient-form');
                if(this.recipientForm){
                    this.recipientForm.errorMessage.setAttribute('data-active', 'false');
                    this.recipientForm.errorMessage.querySelector('.form-status').innerHTML = '';
                    this.recipientForm.querySelectorAll('.input-wrapper').forEach(item => {
                        item.setAttribute('data-invalid', 'false');
                    })
                }

                if(res.status){
                    if(res.errors){
                        var errors = Object.keys(res.errors);
                        if(errors.includes('email')){
                            if(this.recipientForm){
                                let error = document.createElement('li');
                                error.innerHTML = `Email ${res.errors.email}`;
                                this.recipientForm.errorMessage.querySelector('.form-status').appendChild(error);

                                this.recipientForm.errorMessage.setAttribute('data-active', 'true');
                                this.recipientForm.querySelector('.input-wrapper[data-error-msg="email"]').setAttribute('data-invalid', 'true');

                                this.recipientForm.errorMessage.focus();
                            }
                            return;
                        }
                    }

                    if(res.message.includes('is already sold out.')){ // sold out message
                        if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'true');

                        // add sold out message
                        let soldoutBadge = document.createElement('span');
                        soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                        soldoutBadge.classList.add('badge');
                        soldoutBadge.classList.add('badge--sold-out');

                        this.querySelector('.price').appendChild(soldoutBadge);
                        this.querySelector('.price').classList.add('price--sold-out');
                        this.querySelector('.price').classList.remove('price--on-sale');
                    }

                    if(res.description){
                        if(this.querySelector('#product-form .cart-422-error')){
                            this.querySelector('#product-form .cart-422-error').remove();
                        }
                        var errorElem = document.createElement('div');
                        errorElem.className = 'cart-422-error py-3';
                        var errorMessage = res.description;
                        var qtyMatch = errorMessage.match(/(\d+)\s*点/);
                        if(qtyMatch){
                            errorMessage = `在庫数を超えているため、在庫のあるアイテム${qtyMatch[1]}点までカートに追加いたしました。`;
                        }
                        errorElem.textContent = errorMessage;
                        this.querySelector('#product-form').appendChild(errorElem);
                    }
                    return;
                }

                // render item in cart
                if(this.cart){
                    this.cart.renderContent(res);
                }else{
                    this.getCartSize();
                }


                if(this.querySelectorAll('input[name="quantity"]').length > 0){
                    this.querySelectorAll('input[name="quantity"]').forEach(item => {
                        item.value = '1';
                    })
                }
                if(this.recipientForm){
                    this.recipientForm.reset();
                }
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                this.btnCart.setAttribute('data-disabled', 'false');
            })
        }

        getCartSize(){
            const cartItemsIconUrl = `/?section_id=header-cart-icon`;

            fetch(cartItemsIconUrl)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
          
                return res.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                document.querySelector('custom-header .nav-item .cart-count').innerHTML = resultsMarkup.trim();
                document.querySelector('custom-header .nav-item .cart-count').setAttribute('data-hidden', 'false');
            })
        }

        initSwiper(){
            if(!this.swiperContainer) return;
            var swiperSettings = {
                init: true,
                initialSlide: 0,
                loop: false,
                spaceBetween: 0,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true
            }

            swiperSettings.navigation = {
                nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
            }

            swiperSettings.pagination = {
                el: this.swiperContainer.querySelector('.swiper-pagination')
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.checkPagination();
            this.getVisibleSlides();

            this.swiper.on("slideChange", e => {
                this.stopAllVideo();
                this.closeZoomImages();
                this.closeProductModels();
                this.getVisibleSlides();

                // start media
                var currentSlide = this.swiperContainer.querySelector(`.swiper-slide[data-media-idx="${e.realIndex + 1}"]`);
                var mediaType = currentSlide.dataset.mediaType;
                if(mediaType == 'video'){
                    this.startVideo(currentSlide.querySelector('video'), mediaType);
                }else if(mediaType == 'external_video'){
                    this.startVideo(currentSlide.querySelector('iframe'), mediaType);
                }
            })

            this.swiper.on("resize", () => {
                this.checkPagination();
            })

            this.loadMedia();
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        disableTouchSwipe(){
            if(this.swiper) this.swiper.allowTouchMove = false;
        }

        enableTouchSwipe(){
            if(this.swiper) this.swiper.allowTouchMove = true;
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        startVideo(elem, mediaType){
            if(mediaType == 'video'){
                elem.play();
            }else if(mediaType == 'external_video'){
                if(elem.closest('.media-wrapper')){
                    const thumbnail = elem.closest('.media-wrapper').querySelector('.thumbnail');
                    if(thumbnail){
                        thumbnail.style.opacity = '0';
                        thumbnail.style.transitionDuration = '0s';
                    }
                }

                var itemSrc = elem.dataset.src;
                if(elem.getAttribute('src') != ''){
                    if(elem.contentWindow){
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                    return; 
                }

                elem.setAttribute('src', itemSrc);
                elem.onload = function() {
                    if (elem.contentWindow) {
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                };
            }
        }

        closeZoomImages(){
            this.productMediaImages.forEach(item => {
                item.zoomOut();
            })
        }

        closeProductModels(){
            this.productModels.forEach(item => {
                item.closeProductModel();
            })
        }

        scrollMedia(){
            this.productMedia.querySelectorAll('.media-wrapper').forEach(item => {
                var visible = this.isInViewport(item);
                
                if(visible && item.getAttribute('data-active') == 'false' && item.classList.contains('swiper-slide-active')){
                    this.updateMedia(item);
                }
            })
        }

        loadMedia(){
            var activeSlide = this.querySelector('.swiper-slide-active');
            
            if(this.dataset.page == 'featured-product'){ // featured product
                var visible = this.isInViewport(activeSlide);
                if(!visible){
                    if(activeSlide) activeSlide.setAttribute('data-active', 'false');
                    return;
                }
            }

            this.updateMedia(activeSlide);
        }

        updateMedia(elem){
            this.stopAllVideo();
            this.closeZoomImages();
            this.closeProductModels();

            this.productMedia.querySelectorAll('.media-wrapper').forEach(item => {
                item.setAttribute('data-active', 'false');
            })

            elem.setAttribute('data-active', 'true');
            
            var mediaType = elem.dataset.mediaType;

            if(mediaType == 'video'){
                this.startVideo(elem.querySelector('video'), mediaType);
            }else if(mediaType == 'external_video'){
                this.startVideo(elem.querySelector('iframe'), mediaType);
            }
        }

        isInViewport(el){
            if(!el) return;
            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
            );
        }

        stopAllVideo(){
            // external video
            var externalVideos = this.querySelectorAll('product-media iframe');
            externalVideos.forEach(item => {
                // youtube
                if(item.contentWindow)
                    item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');

                // vimeo
                var vimeoUrl = new URL(item.src);
                if (vimeoUrl.hostname.includes('vimeo.com')) {
                    var vimeoData = {
                        method: 'pause'
                    };
                    item.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                    var seekData = {
                        method: 'setCurrentTime',
                        value: 0
                    };
                    item.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
                }
                
                if(item.closest('.media-wrapper')){
                    const thumbnail = item.closest('.media-wrapper').querySelector('.thumbnail');
                    if(thumbnail){
                        thumbnail.style.opacity = '1';
                        thumbnail.style.transition = 'opacity 0.5s ease-in';
                    }
                }
            });

            // video
            var embedVideos = this.querySelectorAll('product-media video');
            embedVideos.forEach(item => {
                item.pause();
                item.currentTime = 0;
            });
        }
    }

    class MainProductDetails extends ProductDetails {
        constructor(){
            super();
        }

        connectedCallback(){
            this.init();

            this.adjustProductMediaTop();
            this._resizeHandler = this.adjustProductMediaTop.bind(this);
            window.addEventListener('resize', this._resizeHandler);
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this._resizeHandler);
        }


        refresh(){
            this.init();
        }

        init(){
            // Product media
            this.productMedia = this.querySelector('product-media');
            this.productMediaImages = this.querySelectorAll('product-media-image');
            this.swiperContainer = (this.productMedia)? this.productMedia.querySelector('.swiper-container') : null;
            this.paginationSwiperContainer = this.productMedia?.querySelector('.pagination-swiper-container');

            this.productModels = this.querySelectorAll('product-model');

            document.addEventListener('DOMContentLoaded', () => {
                if(!this.querySelector('variant-wrapper') && this.productMedia){
                    this.productMedia.setAttribute('data-hidden', 'false');
                }
        
            }, false);

            if(this.swiperContainer){
                if(parseInt(this.swiperContainer.dataset.swiperSize) > 1){
                    this.initSwiper();
                    if (window.innerWidth > 991) {
                        document.addEventListener('scroll', this.scrollMedia.bind(this), false);
                    }
    
                    document.addEventListener('resize', this.scrollMedia.bind(this), false);
                }
            }
            if(this.paginationSwiperContainer) this.initPaginationSwiper();

            // Submit the form
            this.btnCart = this.querySelector('.btn-cart');
            this.buyButtons = this.querySelector('.product-buy-buttons');
            this.form = this.querySelector('#product-form');
            this.cart = document.querySelector('custom-cart-popup');

            this.form.addEventListener('submit', this.submitToCart.bind(this));
        }

        adjustProductMediaTop(){
            const header = document.querySelector('custom-header');
            if(header){
                const headerHeight = header.offsetHeight;
                this.style.setProperty('--product-media-top', `${headerHeight}px`);
            }
        }

        initPaginationSwiper(){
            if(!this.paginationSwiperContainer) return;

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: false,
                spaceBetween: 10,
                speed: 500,
                centeredSlides: false,
                breakpoints: {
                    0: { slidesPerView: 3 },
                    576: {
                        slidesPerView: 5
                    }
                },
                observer: true,
                observeSlideChildren: true,
                watchOverflow: true,
                on: {
                    init: () => {
                        this.isNextSlide(this.paginationSwiper);
                    },
                    resize: () => {
                        this.isNextSlide(this.paginationSwiper);
                    }
                }
            }

            swiperSettings.navigation = {
                nextEl: this.paginationSwiperContainer.querySelector('.swiper-button-next'),
                prevEl: this.paginationSwiperContainer.querySelector('.swiper-button-prev')
            }

            this.paginationSwiper = new Swiper(this.paginationSwiperContainer, swiperSettings);
            this.paginationSwiper.init();

            this.paginationItems = this.paginationSwiperContainer.querySelectorAll('product-media-pagination-thumbnail');
            this.paginationItems.forEach(item => {
                item.addEventListener('click', e => {
                    const currentIndex = parseInt(item.dataset.index);
                    if(!isNaN(currentIndex)){
                        const activeSlide = this.querySelector(`.media-wrapper[data-media-idx="${currentIndex}"]`);
                        if(activeSlide){
                            const index = activeSlide.getAttribute('data-swiper-slide-index')
                                || Array.from(activeSlide.parentElement.children).indexOf(activeSlide);
                            
                            this.swiper.slideTo(index);
                        }
                    }
                });
            })
        }

        isNextSlide(swiper){
            if(!swiper.isEnd){ // there is next slide
                this.paginationSwiperContainer.style.setProperty('--swiper-max-width', 'calc(100% - 45px)');
            }else{
                this.paginationSwiperContainer.style.setProperty('--swiper-max-width', '100%');
            }
        }
    }

    customElements.define('custom-product-details', MainProductDetails);
}

if(!customElements.get('variant-selector')){
    class VariantSelector extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.productDetails = this.closest('custom-product-details, custom-featured-product');
            this.variantPopup = this.closest('variant-popup');
            if(!this.productDetails || this.variantPopup){
                this.initOnPopup();
                return;
            }

            this.productInfo = this.closest('product-info');
            this.variantWrapper = this.closest('variant-wrapper');
            this.variantSelectors = this.variantWrapper.querySelectorAll('variant-selector');

            this.input = this.querySelector('.selected-option');
            this.variantIds = this.productInfo.querySelectorAll('input[name="id"]');
            this.variants = this.querySelectorAll('.product-variant-options li');

            this.variantJsonData = JSON.parse(this.productInfo.querySelector('#script-variant').textContent);

            if(this.variantWrapper.dataset.type == 'dropdown'){
                // selector
                this.btns = this.querySelectorAll('.btn-selected');
                this.options = this.querySelectorAll('li');
                this.btns.forEach(btn => {
                    btn.addEventListener('click', this.openOption.bind(this));
                    btn.addEventListener('focusout', this.closeOption.bind(this));
                    btn.addEventListener('keydown', event => {
                        if(event.key === 'Enter'){
                            this.openOption(event);
                        }
                    })
                    this.options.forEach(item => {
                        item.addEventListener('keydown', this.optionKeydownEventHandler.bind(this));
                    });
                    document.addEventListener('click', (event) => {
                        if(event.target.nodeName === 'VARIANT-SELECTOR' || event.target.closest('variant-selector') !== null){
                        }else{
                            this.closeOption(event);
                        }
                    });

                    // option clicked
                    btn.querySelectorAll('.variant-select-options li').forEach(item => {
                        item.addEventListener('click', e => {
                            this.clickOption(e, btn);
                        })
                        item.addEventListener('keydown', e => {
                            if(e.key === 'Enter'){
                                this.clickOption(e, btn);
                            }
                        })
                    });
                })
            }

            this.variants.forEach(item => {
                item.addEventListener('click', this.changeVariant.bind(this));
                item.addEventListener('keydown', event => {
                    if(event.key === 'Enter'){
                        this.changeVariant(event);
                    }
                })
            });
        }

        optionKeydownEventHandler(event){
            const options = this.querySelectorAll('li:not([tabindex="-1"])');
            if(event.key === 'ArrowDown'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                        focusableElements[nextIndex].focus();
                    }else{
                        this.querySelector('.variant-select-options').setAttribute('data-hidden', 'true');
                        this.querySelectorAll('.variant-select-options li').forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }else if(event.key === 'ArrowUp'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex === 0 ? 0 : currentIndex - 1;
                    focusableElements[nextIndex].focus();
                }
            }else if(event.key === 'Tab'){
                var focusableElements = options;
                var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                var nextIndex = currentIndex + 1;
                if(focusableElements[nextIndex]){
                }else{
                    this.querySelector('.variant-select-options').setAttribute('data-hidden', 'true');
                    this.querySelectorAll('.variant-select-options li').forEach(item => {
                        item.setAttribute('tabindex', '-1');
                    })
                }
            }
        }

        initOnPopup(){
            this.variantPopup = this.closest('.variant-popup');
            this.variantWrapper = this.closest('variant-wrapper');
            this.variantSelectors = this.variantWrapper.querySelectorAll('variant-selector');

            this.input = this.querySelector('.selected-option');
            this.variantIds = this.variantPopup.querySelectorAll('input[name="id"]');
            this.variants = this.querySelectorAll('.product-variant-options li');

            this.variantJsonData = JSON.parse(this.variantPopup.querySelector('#script-variant').textContent);

            this.btns = this.querySelectorAll('.btn-selected');
            this.btns.forEach(btn => {
                btn.addEventListener('click', this.openOption.bind(this));
                btn.addEventListener('focusout', this.closeOption.bind(this));
                btn.addEventListener('keydown', event => {
                    if(event.key === 'Enter'){
                        this.openOption(event);
                    }
                });
                this.options = this.querySelectorAll('li');
                this.options.forEach(item => {
                    item.addEventListener('keydown', this.optionKeydownEventHandler.bind(this));
                });
                document.addEventListener('click', (event) => {
                    if(event.target.nodeName === 'VARIANT-SELECTOR' || event.target.closest('variant-selector') !== null){
                    }else{
                        this.closeOption(event);
                    }
                })

                // option clicked
                btn.querySelectorAll('.variant-select-options li').forEach(item => {
                    item.addEventListener('click', e => {
                        this.clickOption(e, btn);
                    });
                    item.addEventListener('keydown', event => {
                        if(event.key === 'Enter'){
                            this.clickOption(event, btn);
                        }
                    });
                })
            })

            this.variants.forEach(item => {
                item.addEventListener('click', this.changeVariantOnPopup.bind(this))
                item.addEventListener('keydown', event => {
                    if(event.key === 'Enter'){
                        this.changeVariantOnPopup(event);
                    }
                })
            });
        }

        openOption(e){ // for dropdown menu
            e.preventDefault();

            if(e.target.nodeName !== 'LI' && e.target.closest('li') == null){
                e.currentTarget.querySelector('.variant-select-options').setAttribute('data-hidden', 'false');
                e.currentTarget.querySelectorAll('.variant-select-options li').forEach(item => {
                    if(item.dataset.available == 'true'){
                        item.setAttribute('tabindex', '0');
                    }
                })
            }
        }

        closeOption(e){ // for dropdown menu
            if(e.relatedTarget == null || (e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON')){
                this.querySelector('.variant-select-options').setAttribute('data-hidden', 'true');
                this.querySelectorAll('.variant-select-options li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }
        }

        clickOption(e, btn){ // for dropdown menu
            e.currentTarget.closest('.variant-select-options').setAttribute('data-hidden', 'true');
            let optionItems = e.currentTarget.closest('.variant-select-options');
            if(optionItems){
                optionItems.querySelectorAll('li').forEach(item => {
                    item.setAttribute('tabindex', '-1')
                });
            }
            btn.querySelector('.variant').innerHTML = `${e.currentTarget.dataset.option}`;
        }

        changeVariant(e){
            // remove active variant
            this.variants.forEach(item => item.setAttribute('data-active', 'false'));
            e.currentTarget.setAttribute('data-active', 'true'); 

            // add to cart error
            if(this.productInfo.querySelector('.cart-422-error')){
                this.productInfo.querySelector('.cart-422-error').remove();
            }

            // set new variant id
            this.selectedVariants = {
                option1: (this.variantSelectors[0])? this.variantSelectors[0].querySelector('[data-active="true"]').dataset.option : null,
                option2: (this.variantSelectors[1])? this.variantSelectors[1].querySelector('[data-active="true"]').dataset.option : null,
                option3: (this.variantSelectors[2])? this.variantSelectors[2].querySelector('[data-active="true"]').dataset.option : null
            }

            this.setVariantId();

            // set input options[] value
            this.input.value = e.currentTarget.dataset.option;

            // set SKU
            this.setSKU();

            // update label (swatch)
            const swatch = this.querySelector(".variant-selector__swatch");
            if(swatch){
                const swatchLabelValue = e.currentTarget?.dataset.option;
                if(swatchLabelValue){
                    const swatchLabel = this.querySelector(".variant-selector__swatch-label span");
                    if(swatchLabel) swatchLabel.innerText = `${swatchLabelValue}`;
                }
            }
        }

        changeVariantOnPopup(e){
            this.variants.forEach(item => item.setAttribute('data-active', 'false'));
            e.currentTarget.setAttribute('data-active', 'true');

            // add to cart error
            if(this.variantPopup.querySelector('.cart-422-error')){
                this.variantPopup.querySelector('.cart-422-error').remove();
            }

            // set new variant id
            this.selectedVariants = {
                option1: (this.variantSelectors[0])? this.variantSelectors[0].querySelector('[data-active="true"]').dataset.option : null,
                option2: (this.variantSelectors[1])? this.variantSelectors[1].querySelector('[data-active="true"]').dataset.option : null,
                option3: (this.variantSelectors[2])? this.variantSelectors[2].querySelector('[data-active="true"]').dataset.option : null
            }

            this.setVariantId();

            // set input options[] value
            this.input.value = e.currentTarget.dataset.option;
        }

        setVariantId(){
            var newId = 'undefined';
            for(let idx=0; idx < this.variantJsonData.length; idx++){
                var currentVariant = this.variantJsonData[idx];
                if(currentVariant.option1 == this.selectedVariants.option1 &&
                    currentVariant.option2 == this.selectedVariants.option2 &&
                    currentVariant.option3 == this.selectedVariants.option3
                ){
                    // set new variant id
                    newId = this.variantJsonData[idx].id;
                    break;
                }
            }

            this.variantIds.forEach(item => {
                item.setAttribute('value', newId);
            })
        }

        setSKU(){
            // remove active SKU
            this.sku = this.productDetails.querySelectorAll('.product-sku__item');

            if(this.sku){
                this.sku.forEach(item => {
                    let variantId = item.dataset.variantId;
                    item.setAttribute('data-active', variantId == this.variantIds[0].value? 'true': 'false');
                })
            }
        }
    }

    customElements.define('variant-selector', VariantSelector);
}

if(!customElements.get('variant-wrapper')){
    class VariantWrapper extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.productDetails = this.closest('custom-product-details, custom-featured-product');
            this.variantPopup = this.closest('variant-popup');
            this.type = this.dataset.type;

            if(!this.productDetails || this.variantPopup){
                this.initOnPopup();
                return;
            }

            this.productInfo = this.closest('product-info');

            this.productMedia = this.productDetails.querySelector('product-media');
        
            this.variantJsonData = JSON.parse(this.productInfo.querySelector('#script-variant').textContent);
            this.optionsWithValueJsonData = JSON.parse(this.productInfo.querySelector('#script-options-with-values').textContent);
        
            this.buyButtons = this.productInfo.querySelector('.product-buy-buttons');

            this.variantSelectors = this.querySelectorAll('variant-selector');
            this.selectedVariants = {
                option1: (this.variantSelectors[0])? this.variantSelectors[0].querySelector('[data-active="true"]').dataset.option : null,
                option2: (this.variantSelectors[1])? this.variantSelectors[1].querySelector('[data-active="true"]').dataset.option : null,
                option3: (this.variantSelectors[2])? this.variantSelectors[2].querySelector('[data-active="true"]').dataset.option : null
            }

            this.productMediaImages = (this.productMedia)? this.productMedia.querySelectorAll('product-media-image') : null;

            this.price = this.productInfo.querySelector('.price');
            this.priceJsonData = JSON.parse(this.productInfo.querySelector('#script-price').textContent);
            this.priceJsonData = this.priceJsonData.variant_price;

            // event handler when option is updated
            this.variantSelectors.forEach((item, idx) => {
                var variants = item.querySelectorAll('li');
                variants.forEach(variant => {
                    variant.addEventListener('click', e => {
                        if(idx == 0){
                            this.selectedVariants.option1 = e.currentTarget.dataset.option;
                        }else if(idx == 1){
                            this.selectedVariants.option2 = e.currentTarget.dataset.option;
                        }else{
                            this.selectedVariants.option3 = e.currentTarget.dataset.option;
                        }

                        this.updateAvailability();
                        this.checkSoldout();
                        this.checkVariantImage();
                        this.updatePrice();
                        this.updatePickupAvailability();
                        this.updateURL();
                    });

                    variant.addEventListener('keydown', e => {
                        if(e.key === 'Enter'){
                            if(idx == 0){
                                this.selectedVariants.option1 = e.currentTarget.dataset.option;
                            }else if(idx == 1){
                                this.selectedVariants.option2 = e.currentTarget.dataset.option;
                            }else{
                                this.selectedVariants.option3 = e.currentTarget.dataset.option;
                            }
    
                            this.updateAvailability();
                            this.checkSoldout();
                            this.checkVariantImage();
                            this.updatePrice();
                            this.updatePickupAvailability();
                            this.updateURL();
                        }
                    })
                })
            })

            this.updateAvailability();
            this.checkSoldout();
            this.checkVariantImage(true);
            this.updatePrice();
        }

        initOnPopup(){
            this.variantPopup = this.closest('.variant-popup');
            this.productInfo = this.variantPopup;

            this.variantJsonData = JSON.parse(this.variantPopup.querySelector('#script-variant').textContent);
            this.optionsWithValueJsonData = JSON.parse(this.variantPopup.querySelector('#script-options-with-values').textContent);
        
            this.buyButtons = this.variantPopup.querySelector('.product-buy-buttons');
            this.variantSelectors = this.querySelectorAll('variant-selector');
            this.selectedVariants = {
                option1: (this.variantSelectors[0])? this.variantSelectors[0].querySelector('[data-active="true"]').dataset.option : null,
                option2: (this.variantSelectors[1])? this.variantSelectors[1].querySelector('[data-active="true"]').dataset.option : null,
                option3: (this.variantSelectors[2])? this.variantSelectors[2].querySelector('[data-active="true"]').dataset.option : null
            }

            this.price = this.variantPopup.querySelector('.price');
            this.priceJsonData = JSON.parse(this.variantPopup.querySelector('#script-price').textContent);
            this.priceJsonData = this.priceJsonData.variant_price;

            this.productMedia = this.variantPopup.querySelector('.variant-popup__media');

            // event handler when option is updated
            this.variantSelectors.forEach((item, idx) => {
                var variants = item.querySelectorAll('li');
                variants.forEach(variant => {
                    variant.addEventListener('click', e => {
                        if(idx == 0){
                            this.selectedVariants.option1 = e.currentTarget.dataset.option;
                        }else if(idx == 1){
                            this.selectedVariants.option2 = e.currentTarget.dataset.option;
                        }else{
                            this.selectedVariants.option3 = e.currentTarget.dataset.option;
                        }

                        this.checkVariantImage();
                        this.updatePopupAvailability();
                        this.checkSoldout();
                        this.updatePrice();
                    });

                    variant.addEventListener('keydown', e => {
                        if(e.key === 'Enter'){
                            if(idx == 0){
                                this.selectedVariants.option1 = e.currentTarget.dataset.option;
                            }else if(idx == 1){
                                this.selectedVariants.option2 = e.currentTarget.dataset.option;
                            }else{
                                this.selectedVariants.option3 = e.currentTarget.dataset.option;
                            }
    
                            this.checkVariantImage();
                            this.updateAvailability();
                            this.checkSoldout();
                            this.updatePrice();
                        }
                    })
                })
            })

            this.checkVariantImage(true, true);
            this.updateAvailability();
            this.checkSoldout();
            this.updatePrice();
        }

        updateAvailability(){
            this.variantSelectors.forEach(item => {
                var variants = item.querySelectorAll('li');
                variants.forEach(variant => {
                    variant.setAttribute('data-available', 'true');

                    if(this.type === 'button')
                        variant.setAttribute('tabindex',  '0');
                })
            })

            this.selectedVariants.option1 = this.variantSelectors[0]? this.variantSelectors[0].querySelector('[data-active="true"]').dataset.option : null;

            this.selectedVariantsOptions = [];

            var selectedVariantsOptions1 = this.orderByOptionTitle(this.selectedVariants.option1, 1, this.variantJsonData);
            if(this.optionsWithValueJsonData.length == 3){
                var selectedVariantsOptions2 = this.orderByOptionTitle(this.selectedVariants.option2, 2, selectedVariantsOptions1);
                this.orderByOptionTitle(this.selectedVariants.option3, 3, selectedVariantsOptions2);
            }else if(this.optionsWithValueJsonData.length == 2){
                this.orderByOptionTitle(this.selectedVariants.option2, 2, selectedVariantsOptions1);
            }
        }

        updatePopupAvailability(){
            this.variantSelectors.forEach(item => {
                var variants = item.querySelectorAll('li');
                variants.forEach(variant => {
                    variant.setAttribute('data-available', 'true');

                    if(this.type === 'button')
                        variant.setAttribute('tabindex',  '0');
                })
            })
            this.selectedVariantsOptions = [];
            var selectedVariantsOptions1 = this.orderByOptionTitle(this.selectedVariants.option1, 1, this.variantJsonData);
            if(this.optionsWithValueJsonData.length == 3){
                var selectedVariantsOptions2 = this.orderByOptionTitle(this.selectedVariants.option2, 2, selectedVariantsOptions1);
                this.orderByOptionTitle(this.selectedVariants.option3, 3, selectedVariantsOptions2);
            }else if(this.optionsWithValueJsonData.length == 2){
                this.orderByOptionTitle(this.selectedVariants.option2, 2, selectedVariantsOptions1);
            }
        }

        orderByOptionTitle(selectedVariants, index, selectedOptionList = this.variantJsonData){
            var optionList = {};
            var selectedVariantsOptions = [];

            for(let idx=0; idx<selectedOptionList.length; idx++){
                // check available variant
                var currentOption = selectedOptionList[idx]["option" + index];

                if(currentOption in optionList){
                    optionList[currentOption].push(selectedOptionList[idx]);
                }else{
                    optionList[currentOption] = [ selectedOptionList[idx] ];
                }

                // add option children items to array
                if(selectedOptionList[idx]["option" + index] == selectedVariants){
                    selectedVariantsOptions.push(selectedOptionList[idx]);
                }
            }

            // check variants availability
            for(var variant in optionList){
                var availability = [];
                for(let ind=0; ind<optionList[variant].length; ind++){
                    availability.push(optionList[variant][ind].available);
                }

                if(availability.includes(true) == false){
                    this.variantSelectors[index - 1].querySelectorAll('li').forEach(item => {
                        if(item.dataset.option == variant){
                            item.setAttribute('data-available', 'false');

                            if(this.type === 'button')
                                item.setAttribute('tabindex', '-1');
                        }
                    })
                }
            }

            if(index != 1){
                // if variant doesn't exist in variant options, set it to false
                var selectedVariantsKeys = Object.keys(optionList);
                this.variantSelectors[index - 1].querySelectorAll('li').forEach(item => {
                    if((selectedVariantsKeys.includes(item.dataset.option)) == false){
                        item.setAttribute('data-available', 'false');

                        if(this.type === 'button')
                            item.setAttribute('tabindex', '-1');
                    }
                })
            }

            return selectedVariantsOptions;
        }
        
        checkSoldout(){
            var noOptionExist = true;

            // remove soldout message
            if(this.productInfo.querySelector('.badge--sold-out')){
                this.productInfo.querySelector('.badge--sold-out').remove();
            }
            if(this.productInfo.querySelector('.badge--sale')){
                this.productInfo.querySelector('.badge--sale').remove();
            }

            for(let idx=0; idx<this.variantJsonData.length; idx++){
                var currentVariant = this.variantJsonData[idx];

                if(currentVariant.option1 == this.selectedVariants.option1
                    && currentVariant.option2 == this.selectedVariants.option2
                    && currentVariant.option3 == this.selectedVariants.option3
                ){
                    // check if available
                    if(!currentVariant.available){

                        if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'true');

                        // add sold out message
                        let soldoutBadge = document.createElement('span');
                        soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                        soldoutBadge.classList.add('badge');
                        soldoutBadge.classList.add('badge--sold-out');

                        this.productInfo.querySelector('.price').appendChild(soldoutBadge);
                        this.productInfo.querySelector('.price').classList.add('price--sold-out');

                    }else{

                        if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'false');

                    }

                    noOptionExist = false;
                }
            }

            if(noOptionExist){
                if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'true');

                // add sold out message
                let soldoutBadge = document.createElement('span');
                soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                soldoutBadge.classList.add('badge');
                soldoutBadge.classList.add('badge--sold-out');

                this.productInfo.querySelector('.price').appendChild(soldoutBadge);
                this.productInfo.querySelector('.price').classList.add('price--sold-out');
            }
        }

        updateURL(){
            var variantId = this.productInfo.querySelector('input[name="id"]').value;

            window.history.replaceState({ }, '', `${this.dataset.url}?variant=${variantId}`);
        }

        checkVariantImage(onload = false, onPopup = false){
            if(!this.productMedia) return;

            if(onload){

                if(onPopup){
                    setTimeout(() => {
                        this.updateVariantImage();
                    }, 500);
                }else{
                    window.addEventListener('load', () => {
                        this.updateVariantImage();
                        this.productMedia.setAttribute('data-hidden', 'false');
                    });
                }

                return;
            }
            
            this.updateVariantImage();
        }

        updateVariantImage(){
            for(let idx=0; idx<this.variantJsonData.length; idx++){
                var currentVariant = this.variantJsonData[idx];

                if(currentVariant.option1 == this.selectedVariants.option1
                    && currentVariant.option2 == this.selectedVariants.option2
                    && currentVariant.option3 == this.selectedVariants.option3
                ){
                    // check if featured image exists
                    if(currentVariant.featured_image){
                        //get product id of featured image
                        var mediaId = currentVariant.featured_media.id;

                        this.productMedia.querySelectorAll('.media-wrapper').forEach(item => {
                            if(parseInt(item.dataset.mediaId) == mediaId){
                                // select current item - slide
                                var mediaIdx = parseInt(item.dataset.mediaIdx) - 1;

                                if(this.productDetails){
                                    this.productDetails.swiper.params.speed = 0;
                                    this.productDetails.swiper.slideTo(mediaIdx);
                                    this.productDetails.swiper.params.speed = 500;
                                }else if(this.closest('variant-popup')){
                                    const productId = this.closest('variant-popup').dataset.productId;
                                    if(productId){
                                        const productForm = document.querySelector(`product-form[data-product-id="${productId}"]`);
                                        
                                        if(productForm){
                                            productForm.swiper.params.speed = 0;
                                            productForm.swiper.slideTo(mediaIdx);
                                            productForm.swiper.params.speed = 500;
                                        }
                                    }
                                }
                            }
                        })
                    }
                }
            }
        }

        updatePrice(){
            for(let idx=0; idx<this.variantJsonData.length; idx++){
                var currentVariant = this.variantJsonData[idx];

                if(currentVariant.option1 == this.selectedVariants.option1
                    && currentVariant.option2 == this.selectedVariants.option2
                    && currentVariant.option3 == this.selectedVariants.option3
                ){
                    if(currentVariant.available){
                        
                        // update price
                        this.price.classList.remove('price--sold-out');
                        this.price.classList.remove('price--on-sale');
                        this.price.classList.remove('price--no-compare');

                        this.price.querySelectorAll('.price__sale .price-item').forEach(item => {
                            item.innerHTML = '';
                        });

                        this.price.querySelectorAll('.badge').forEach(item => {
                            item.remove();
                        });

                        var currentVariantId = currentVariant.id;

                        for(let ind=0; ind<this.priceJsonData.length; ind++){
                            if(currentVariantId == this.priceJsonData[ind].id){
                                var currentVariantPrice = this.priceJsonData[ind];
                                var price = currentVariantPrice.price;

                                // sale price
                                if(currentVariant.compare_at_price != null){
                                    var compareAtPrice = currentVariantPrice.compare_at_price;
                                    if(this.price.querySelector('.price__sale .price-item--compare'))
                                        this.price.querySelector('.price__sale .price-item--compare').innerHTML = compareAtPrice;

                                    if(this.price.querySelector('.price__sale .price-item:not(.price-item--compare)'))
                                        this.price.querySelector('.price__sale .price-item:not(.price-item--compare)').innerHTML = price;
                                
                                    this.price.classList.add('price--on-sale');

                                    let onsaleBadge = document.createElement('span');
                                    onsaleBadge.innerHTML = (window.smallText.saleText)? window.smallText.saleText : 'SALE';
                                    onsaleBadge.classList.add('badge');
                                    onsaleBadge.classList.add('badge--sale');
                                    onsaleBadge.classList.add('mx-2');

                                    this.price.appendChild(onsaleBadge);
                                }else{
                                    this.price.querySelector('.price__regular .price-item').innerHTML = price;
                                }

                                // unit price
                                if(currentVariantPrice.unit_price != null){
                                    let priceItemWrapper = document.createElement('span');
                                    priceItemWrapper.classList.add('price-item');
                                    
                                    let priceUnitMoney = document.createElement('span');
                                    priceUnitMoney.classList.add('price__unit--money');
                                    priceUnitMoney.innerHTML = currentVariantPrice.unit_price.price;

                                    let priceUnitPer = document.createElement('span');
                                    priceUnitPer.classList.add('price__unit--per');
                                    priceUnitPer.innerHTML = 'per';

                                    let priceUnitRef = document.createElement('span');
                                    priceUnitRef.classList.add('price__unit--ref');
                                    priceUnitRef.innerHTML = currentVariantPrice.unit_price.reference_value != -1? `${currentVariantPrice.unit_price.reference_value}${currentVariantPrice.unit_price.reference_unit}` : `${currentVariantPrice.unit_price.reference_unit}`; 

                                    priceItemWrapper.appendChild(priceUnitMoney);
                                    priceItemWrapper.appendChild(priceUnitPer);
                                    priceItemWrapper.appendChild(priceUnitRef);

                                    if(this.productInfo.querySelector('.price__unit')){
                                        this.productInfo.querySelector('.price__unit').innerHTML = '';
                                        this.productInfo.querySelector('.price__unit').appendChild(priceItemWrapper);
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }

        updatePickupAvailability(){
            var variantId = this.productInfo.querySelector('input[name="id"]').value;

            if(this.productDetails.getAttribute('data-edit-mode-on')){
                for(let idx=0; idx<this.variantJsonData.length; idx++){
                    var currentVariant = this.variantJsonData[idx];

                    if(currentVariant.option1 == this.selectedVariants.option1
                        && currentVariant.option2 == this.selectedVariants.option2
                        && currentVariant.option3 == this.selectedVariants.option3
                    ){
                        variantId = currentVariant.id;
                    }
                }
            }
            
            this.pickupAvailability = this.productInfo.querySelector('pickup-availability');

            if(this.pickupAvailability){
                this.pickupAvailability.setAttribute('data-variant-id', variantId);
                this.pickupAvailability.updateVariantId();
            }
        }
    }

    customElements.define('variant-wrapper', VariantWrapper);
}

if(!customElements.get('product-form')){
    class ProductForm extends HTMLElement {
        constructor(){
            super();
            
            this.init();
        }

        init(){
            this.form = this.querySelector('form');
            this.cart = document.querySelector('custom-cart-popup');
            this.btnCart = this.querySelector('.btn-cart');
            this.productCard = this.closest('.product-card');

            if(this.closest('.shopify-section')){
                this.popupVariant = this.closest('.shopify-section').querySelector('variant-popup');
            }

            if(this.btnCart){
                this.btnCart.addEventListener('click', this.submitToCart.bind(this));
            }

            this.addEventListener('keydown', (event) => {
                if(event.key === 'Escape'){
                    this.closeVariantPopup();
                }
            });
        }

        refresh(){
            this.init();
        }

        submitToCart(e){
            var item = e.currentTarget;
            if(item.dataset.variant == 'true'){ // new popup exists
                this.openVariantPopup();
                return;
            }

            if(item.getAttribute('data-disabled') == 'true'){
                return;
            }

            this.item = item;

            const formData = new FormData(this.form);
            
            this.item.setAttribute('data-disabled', 'true');

            //config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch('/cart/add', config)
            .then(res => res.json())
            .then(res => {
                if(res.status){
                    // sold out message
                    this.btnCart.closest('product-form').classList.add('d-none');
                    this.btnCart.remove();

                    // add soldout message
                    if(this.closest('.product-card, .product-info').querySelector('.price')){
                        let soldoutBadge = document.createElement('span');
                        soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                        soldoutBadge.classList.add('badge');
                        soldoutBadge.classList.add('badge--sold-out');

                        this.closest('.product-card').querySelector('.price').appendChild(soldoutBadge);
                        this.closest('.product-card').querySelector('.price').classList.add('price--sold-out');

                        this.error = true;
                    }
                }

                if(this.error != true){
                    // render item in cart
                    if(this.cart){
                        this.cart.renderContent(res);
                    }else{
                        this.getCartSize();
                    }
                }
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                this.btnCart.setAttribute('data-disabled', 'false');
            })
        }

        getCartSize(){
            const cartItemsIconUrl = `/?section_id=header-cart-icon`;

            fetch(cartItemsIconUrl)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
          
                return res.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                document.querySelector('custom-header .nav-item .cart-count').innerHTML = resultsMarkup.trim();
                document.querySelector('custom-header .nav-item .cart-count').setAttribute('data-hidden', 'false');
            })
        }

        submitVariantToCart(e){
            e.preventDefault();

            if(this.btnCart.getAttribute('data-disabled') == 'true') return;

            const formData = new FormData(this.form);
            this.btnCart.setAttribute('data-disabled', 'true');

            // add form inputs
            if(this.popupVariant.querySelectorAll('[data-product-input]').length > 0){
                this.popupVariant.querySelectorAll('[data-product-input]').forEach(item => {
                    formData.append(item.getAttribute('name'), item.value);
                })
            }

            // config
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            // remove sold out message
            if(this.popupVariantContent.querySelector('.badge--sold-out')){
                this.popupVariantContent.querySelector('.price').classList.remove('price--sold-out');
                this.popupVariantContent.querySelector('.badge--sold-out').remove();
            }

            fetch('/cart/add', config)
            .then(res => res.json())
            .then(res => {
                if(res.status){
                    if(this.buyButtons) this.buyButtons.setAttribute('data-hidden', 'true');

                    // add sold out message
                    let soldoutBadge = document.createElement('span');
                    soldoutBadge.innerHTML = window.smallText.soldOutText? window.smallText.soldOutText : "SOLD OUT";
                    soldoutBadge.classList.add('badge');
                    soldoutBadge.classList.add('badge--sold-out');

                    this.popupVariantContent.querySelector('.price').appendChild(soldoutBadge);
                    this.popupVariantContent.querySelector('.price').classList.add('price--sold-out');
                }

                if(res.description){
                    // error
                    if(this.popupVariantContent.querySelector('#product-form .cart-422-error')){
                        this.popupVariantContent.querySelector('#product-form .cart-422-error').remove();
                    }
                    var errorElem = document.createElement('div');
                    errorElem.className = 'cart-422-error py-3';
                    var errorMessage = res.description;
                    var qtyMatch = errorMessage.match(/(\d+)\s*点/);
                    if(qtyMatch){
                        errorMessage = `在庫数を超えているため、在庫のあるアイテム${qtyMatch[1]}点までカートに追加いたしました。`;
                    }
                    errorElem.textContent = errorMessage;
                    this.popupVariantContent.querySelector('#product-form').appendChild(errorElem);
                }else{
                    // render item in cart
                    if(this.cart){
                        this.cart.renderContent(res);
                    }else{
                        this.getCartSize();
                    }
                }

            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                this.btnCart.setAttribute('data-disabled', 'false');

                // close variant popup if no error
                if(this.popupVariantContent.querySelectorAll('.cart-422-error').length == 0){
                    this.closeVariantPopup();
                }
            })
        }

        openVariantPopup(){
            if(this.form == null){
                this.init();
            }

            this.previouslyFocusedElement = document.activeElement;

            this.popupVariant.setAttribute('data-hidden', 'false');
            this.popupVariant.setAttribute('data-product-id', `${this.dataset.productId}`);

            // body not to be scrollable
            document.querySelector('html').style.overflow = 'hidden';
            
            this.popupVariantContent = this.popupVariant.querySelector('.variant__product');
            this.popupVariant.querySelectorAll('[data-type="close"]').forEach(item => {
                item.addEventListener('click', this.closeVariantPopup.bind(this));
            })
            this.popupVariantLoadingBar = this.popupVariant.querySelector('#variant-popup__loading-state');
            this.popupVariantLoadingBar.setAttribute('data-hidden', 'false');
            
            this.popupVariant.addEventListener('click', e => {
                if(e.target === this.popupVariant) this.closeVariantPopup();
            })
            this.popupVariant.addEventListener('keyup', e => {
                if(e.code?.toUpperCase() === 'ESCAPE') this.closeVariantPopup();
            })

            // get variant list from product details page
            var productLink = this.dataset.productLink;
            productLink = productLink.split('?');
            productLink = productLink[0];
            this.productLink = `${productLink}?section_id=product-variant-details`;

            if(this.productCard){
                const swatchSelector = this.productCard.querySelector('.variant-swatch-selector');
                if(swatchSelector){
                    const selectedSwatchVariant = swatchSelector.querySelector('input[type="radio"]:checked');
                    if(selectedSwatchVariant){
                        this.productLink = `${this.productLink}&option_values=${selectedSwatchVariant.dataset.optionValueId}`;
                    }   
                }
            }

            fetch(`${this.productLink}`)
            .then(res => {
                if(!res.ok){
                    var error = new Error(res.status);
                    throw error;
                }

                return res.text();
            })
            .then(text => {
                const productVariantDetails = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-product-variant-details');
                const productMediaElements = productVariantDetails.querySelectorAll('.product-media');

                productMediaElements.forEach(elem => elem.remove());

                const resultsMarkup = productVariantDetails.innerHTML;
                this.popupVariantContent.innerHTML = resultsMarkup;

                const productMediaMarkup = Array.from(productMediaElements).map(element => element.outerHTML).join('');

                if(this.popupVariant.querySelector('.variant-popup__media')){
                    const popupVariantMedia = this.popupVariant.querySelector('.variant-popup__media');
                    popupVariantMedia.innerHTML = productMediaMarkup;

                    // add media control
                    var videoIdx = 0;
                    popupVariantMedia.querySelectorAll('video, iframe').forEach(item => {
                        if(videoIdx == 0){
                            var mediaType = item.nodeName == 'IFRAME'? 'external_video' : 'video';
                            this.startVideo(item, mediaType);
                        }
                        videoIdx++;
                    });

                    this.productMedia = this.popupVariant.querySelector('.product-media');
                    this.productMediaImages = this.popupVariant.querySelectorAll('product-media-image');
                    this.swiperContainer = (this.productMedia)? this.productMedia.querySelector('.swiper-container') : null;
                    this.productModels = this.querySelectorAll('product-model');

                    setTimeout(() => {
                        this.productMedia.setAttribute('data-hidden', 'false');
                    }, 500);

                    this.initSwiperInPopup();
                }


                setTimeout(() => {
                    requestAnimationFrame(() => {
                        if (this.popupVariant && this.popupVariant.scrollTop !== 0) {
                            this.popupVariant.scrollTop = 0;
                        }
                    });
                }, 1);

                this.popupVariantLoadingBar.setAttribute('data-hidden', 'true');

                this.form = this.popupVariantContent.querySelector('#product-form');
                this.cart = document.querySelector('custom-cart-popup');
                this.buyButtons = this.popupVariantContent.querySelector('.product-buy-buttons');
                this.btnCart = this.popupVariantContent.querySelector('.btn-cart');
                if(this.btnCart){
                    if(this.btnCart.dataset.effect === 'wave'){
                        const svgString = `
                        <svg class="editorial" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" width="200px">
                          <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 
                                68-18 88-18s
                                68 18 88 18 
                                68-18 88-18 
                                68 18 88 18
                                v44h-352z"></path>
                          </defs>
                          <g class="parallax">
                            <use xlink:href="#gentle-wave" x="40" y="10" fill="#ffffff"></use>  
                            <use xlink:href="#gentle-wave" x="30" y="10" fill="#ffffff" fill-opacity="0.2"></use>  
                          </g>
                        </svg>`;
                
                        const parser = new DOMParser();
                        const svgElement = parser.parseFromString(svgString, 'image/svg+xml').documentElement;

                        const svgClone = svgElement.cloneNode(true);
                        if(!this.btnCart.querySelector('svg')){
                            this.btnCart.appendChild(svgClone);
                        }

                        this.btnCart.addEventListener("click", function(event){
                            const ripple = document.createElement('span');
                            ripple.classList.add('wave-ripple');
              
                            const rect = this.getBoundingClientRect();
                            const size = Math.max(rect.width, rect.height);
                            const x = event.clientX - rect.left - size / 2;
                            const y = event.clientY - rect.top - size / 2;
              
                            ripple.style.width = ripple.style.height = `${size}px`;
                            ripple.style.left = `${x}px`;
                            ripple.style.top = `${y}px`;
              
                            this.appendChild(ripple);
              
                            ripple.addEventListener('animationend', () => {
                                ripple.remove();
                            });
                        })
                    }
                }

                if(this.innerWrapper){
                    setTimeout(() => {
                        this.innerWrapper.scrollTop = 0;
                    }, 300);
                }
                setTimeout(() => {
                    // hide loading
                    this.popupVariantLoadingBar.setAttribute('data-hidden', 'true');
                }, 500);

                this.form.addEventListener('submit', this.submitVariantToCart.bind(this));

                // focus
                this.popupVariantContent.querySelectorAll('[tabindex]:not([tabindex="-1"])')[0].focus();
            })
            .catch((error) => {
                console.error(error);
            });
        }

        initSwiperInPopup(){
            if(!this.swiperContainer) return;
            var swiperSettings = {
                init: true,
                initialSlide: 0,
                loop: false,
                spaceBetween: 0,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true
            }

            swiperSettings.navigation = {
                nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
            }

            swiperSettings.pagination = {
                el: this.swiperContainer.querySelector('.swiper-pagination')
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.checkPagination();
            this.getVisibleSlides();

            this.swiper.on("slideChange", e => {
                this.stopAllVideo();
                this.getVisibleSlides();

                // start media
                var currentSlide = this.swiperContainer.querySelector(`.swiper-slide[data-media-idx="${e.realIndex + 1}"]`);
                var mediaType = currentSlide.dataset.mediaType;
                if(mediaType == 'video'){
                    this.startVideo(currentSlide.querySelector('video'), mediaType);
                }else if(mediaType == 'external_video'){
                    this.startVideo(currentSlide.querySelector('iframe'), mediaType);
                }
            });

            this.swiper.on("resize", () => {
                this.checkPagination();
            });
        }

        stopAllVideo(){
            // external video
            var externalVideos = this.swiperContainer.querySelectorAll('iframe');
            externalVideos.forEach(item => {
                // youtube
                if(item.contentWindow)
                    item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');

                // vimeo
                var vimeoUrl = new URL(item.src);
                if (vimeoUrl.hostname.includes('vimeo.com')) {
                    var vimeoData = {
                        method: 'pause'
                    };
                    item.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                    var seekData = {
                        method: 'setCurrentTime',
                        value: 0
                    };
                    item.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
                }
                
                if(item.closest('.media-wrapper')){
                    const thumbnail = item.closest('.media-wrapper').querySelector('.thumbnail');
                    if(thumbnail){
                        thumbnail.style.opacity = '1';
                        thumbnail.style.transition = 'opacity 0.5s ease-in';
                    }
                }
            });

            // video
            var embedVideos = this.swiperContainer.querySelectorAll('video');
            embedVideos.forEach(item => {
                item.pause();
                item.currentTime = 0;
            });
        }

        checkPagination(){
            var pagination = this.popupVariant.querySelector('.swiper-pagination');
            var btns = {
                prev: this.popupVariant.querySelector('.swiper-button-prev'),
                next: this.popupVariant.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        closeVariantPopup(){
            this.popupVariant.setAttribute('data-hidden', 'true');
            this.popupVariant.removeAttribute('data-product-id');

            this.popupVariantContent.innerHTML = '';

            this.stopVideo();

            // body not to be scrollable
            document.querySelector('html').style.overflow = 'initial';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        startVideo(elem, mediaType){
            if(mediaType == 'video'){
                elem.play();
            }else if(mediaType == 'external_video'){
                var itemSrc = elem.dataset.src;
                if(elem.getAttribute('src') != ''){
                    if(elem.contentWindow){
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                    return; 
                }

                elem.setAttribute('src', itemSrc);
                elem.onload = function() {
                    if (elem.contentWindow) {
                        // youtube
                        elem.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                        elem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

                        // vimeo
                        var vimeoUrl = new URL(elem.src);
                        if (vimeoUrl.hostname.includes('vimeo.com')) {
                            var vimeoMuteData = {
                                method: 'setVolume',
                                value: 0  // Set volume to 0 (mute)
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoMuteData), "*");

                            var vimeoData = {
                                method: 'play'
                            };
                            elem.contentWindow.postMessage(JSON.stringify(vimeoData), "*");
                        }
                    }
                };
            }
        }

        stopVideo(){
            var externalVideos = this.popupVariant.querySelectorAll('iframe');
            externalVideos.forEach(item => {

                // youtube
                if(item.contentWindow)
                    item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');

                // vimeo
                var vimeoUrl = new URL(item.src);
                if (vimeoUrl.hostname.includes('vimeo.com')) {
                    var vimeoData = {
                        method: 'pause'
                    };
                    item.contentWindow.postMessage(JSON.stringify(vimeoData), vimeoUrl.origin);
                    var seekData = {
                        method: 'setCurrentTime',
                        value: 0
                    };
                    item.contentWindow.postMessage(JSON.stringify(seekData), vimeoUrl.origin);
                }
                
            });

            var embedVideos = this.popupVariant.querySelectorAll('video');
            embedVideos.forEach(item => {
                item.removeAttribute('data-active');
                item.pause();
                item.currentTime = 0;
            });
        }
    }
    customElements.define('product-form', ProductForm);
}